import { gql } from '~/tada/gql'
import { defineStore } from 'pinia'
import type { User as UserType } from 'oidc-client-ts'

export const useSession = defineStore('session', () => {
  const { $um } = useNuxtApp()
  const route = useRoute()

  const impersonating = ref<String | null>(
    window.localStorage.getItem('sato48:impersonate'),
  )

  const sso = ref<UserType | null>(null)
  /** True once we know whether anyone is signed in. */
  const ready = ref(false)
  $um.getUser().then(user => {
    sso.value = user
  }).finally(() => {
    ready.value = true
  })
  const roles = computed<string[]>(
    () => (sso.value?.profile.roles as string[]) || [],
  )

  const { result, loading } = useQuery(Whoami, {}, () => ({
    enabled: sso.value != null,
  }))
  const user = computed(() => result.value?.users[0])
  const isAuthenticated = computed(() => !!user.value)

  const impersonate = async (id?: number) => {
    if (id) {
      window.localStorage.setItem('sato48:impersonate', id.toString())
      $um.signinRedirect({
        scope: `openid offline email impersonate.${id}`,
      })
    } else {
      window.localStorage.clear()
      $um.signinRedirect({
        scope: `openid offline email`,
      })
    }
  }

  if (route.hash.startsWith('#impersonate=')) {
    impersonate(parseInt(route.hash.replace('#impersonate=', '')))
  }

  return {
    loading,
    ready,
    sso,
    user,
    roles,
    isAuthenticated,
    impersonate,
    impersonating,
  }
})

const User = gql(`fragment User on users @_unmask {
  id name email sub picture
}`)

const Whoami = gql(
  `query Whoami {
  users {
    ...User
  }
}`,
  [User],
)
